/*============================================================================
  APP-PRODUCT.js - Product-specific functionality
  Only loads on product pages
  Contains: Product galleries, swatches, zoom, quick shop, recommendations
=============================================================================*/

/*============================================================================
  Product
=============================================================================*/
var globalPlayersArray = [];

var product = {
  zoomObserver: null,
  init: function(){
    var $notify_form = $('.notify_form .contact-form');
    var $productGalleries = $('.product-gallery:not([data-quickshop-gallery] .product-gallery)');
    var galleriesArray = [];
    globalPlayersArray = [];

    if ($productGalleries.length > 0) {
      $.each($productGalleries, function(index, gallery) {
        var $productSection = $(gallery).closest('.product_section');
        galleriesArray.push({
          element: $(gallery),
          productSection: $productSection,
          thumbnailsEnabled: $productSection.data('thumbnails-enabled'),
          thumbnailsSliderEnabled: $productSection.data('thumbnails-slider-enabled'),
          thumbnailsPosition: $productSection.data('thumbnails-position'),
          thumbnailsArrows: $productSection.data('gallery-arrows-enabled'),
          slideshowAnimation: $productSection.data('slideshow-animation'),
          slideShowSpeed: $productSection.data('slideshow-speed'),
          activateZoom: $productSection.data('activate-zoom'),
          productMediaSupported: $productSection.data('product-media-supported'),
          videos: $(gallery).find('[data-html5-video] video, [data-youtube-video]').get(),
          hasVideoMedia: $(gallery).find('[data-html5-video], [data-youtube-video]').length > 0,
          loopingEnabled: $(gallery).find('.product-gallery__main').data('video-looping-enabled'),
          sectionID: $productSection.parents('.shopify-section').attr('id')
        })
      })
    }

    if (galleriesArray.length > 0) {
      $.each(galleriesArray, function(index, galleryObject) {
        product.enableSlider(galleryObject);

        if (galleryObject.productMediaSupported) {
          product.launchProductMedia(galleryObject);
        }

        if (galleryObject.activateZoom) {
          product.initZoom(galleryObject.element);
        }
      })
    }

    this.initProductRecommendations();
    this.productSwatches();
    animate_content.init();
  },

  productSwatches: function() {
    $('.product_form.product_form_options.init').each(function() {
      new Shopify.OptionSelectors($(this).data("select-id"), {
        product: $(this).data("product"),
        onVariantSelected: selectCallback,
        enableHistoryState: $(this).data("enable-state")
      });
    });

    
  },

  enableZoom: function(image) {
    var $image = $(image);
    var zoomSrc = $image.data('zoom-src');
    if (zoomSrc && !$image.parent().hasClass('zoom-container')) {
      $image.wrap('<span class="zoom-container"></span>')
        .css('display', 'block')
        .parent()
        .zoom({
          url: zoomSrc,
          touch: false,
          magnify: 1,
        });
    }
  },

  initZoom: function(context) {
    var $context = context ? $(context) : $(document);
    var $images = $context.find('img[data-zoom-src]');

    function bindOneTimeInteraction(image) {
      var handler = function() {
        image.removeEventListener('mouseenter', handler);
        image.removeEventListener('focus', handler);
        image.removeEventListener('click', handler);
        product.enableZoom(image);
      };

      image.addEventListener('mouseenter', handler, { once: true });
      image.addEventListener('focus', handler, { once: true });
      image.addEventListener('click', handler, { once: true });
    }

    $images.each(function() {
      var image = this;

      if (image.dataset.zoomInitialized === 'true') {
        return;
      }

      image.dataset.zoomInitialized = 'true';
      bindOneTimeInteraction(image);
    });

    if ('IntersectionObserver' in window) {
      if (!product.zoomObserver) {
        product.zoomObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              observer.unobserve(entry.target);
              product.enableZoom(entry.target);
            }
          });
        }, {
          rootMargin: '200px 0px'
        });
      }

      $images.each(function() {
        if (!$(this).parent().hasClass('zoom-container')) {
          product.zoomObserver.observe(this);
        }
      });
    }
  },

  enableSlider: function(galleryObject) {
    var $el = galleryObject.element.find('.product-gallery__main');
    var $thumbnailProductGallery = galleryObject.element.find('.product-gallery__thumbnails');
    var $slides = $el.find('.product-gallery__image');
    var $thumbnails = $thumbnailProductGallery.find('.product-gallery__thumbnail');
    product.bindGalleryPlyrLoad(galleryObject, $el, $thumbnails);
    var arrowShape = 'M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z';

    $el.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      dragThreshold: 10,
      imagesLoaded: true,
      pageDots: false,
      prevNextButtons: $el.data('media-count') > 1 ? true : false,
      autoPlay: galleryObject.slideShowSpeed * 1000,
      fade: galleryObject.slideShowAnimation === 'fade' ? true : false,
      watchCSS: false,
      arrowShape: arrowShape
    })

    var $slides = $el.find('.product-gallery__image');

    $el.on('change.flickity', function() {
      $slides.each(function(index, slide) {
        var $slide = $(slide);
        var mediaType = $slide.data('media-type');

        if ($slide.hasClass('is-selected')) {
          switch(mediaType) {
            case 'model':
              if (Shopify.media_queries.large.matches) {
                $slide.on('mouseenter', function() {
                  $el.flickity('unbindDrag');
                });
                $slide.on('mouseleave', function() {
                  $el.flickity('bindDrag');
                });
              }
              $slide.find('model-viewer').on('shopify_model_viewer_ui_toggle_play', function(){
                $el.flickity('unbindDrag');
              })
              $slide.find('model-viewer').on('shopify_model_viewer_ui_toggle_pause', function(){
                $el.flickity('bindDrag');
              })
              break;
          }
        } else {
          switch(mediaType) {
            case 'model':
              if (galleryObject.models && galleryObject.models.length > 0) {
                $.each(galleryObject.models, function(index, model) {
                  model.pause();
                })
              }
              break;
            case 'video':
              var $htmlVideo = $slide.find('[data-html5-video]');
              var videoID = $htmlVideo.find('video').data('plyr-video-id');
              if ($htmlVideo.length && galleryObject.videoPlayers) {
                $.each(galleryObject.videoPlayers, function(index, player) {
                  if (player.id == videoID) {
                    player.pause();
                  }
                })
              }
              break;
            case 'external_video':
              var $iframeVideo = $slide.find('iframe');
              var iframeID = $iframeVideo.attr('id');
              if ($iframeVideo.length && galleryObject.videoPlayers) {
                $.each(galleryObject.videoPlayers, function(index, player) {
                  if (player.media.id == iframeID) {
                    player.pause();
                  }
                })
              }
              break;
          }
        }
      })
    })

    setTimeout(function() {
      $el.flickity('resize');
    }, 500);

    $( window ).on( 'load', function() {
      $el.flickity('resize');
    });

    $slides.each(function(index, slide) {
      var $slide = $(slide);
      var mediaType = $slide.data('media-type');

      if ($slide.hasClass('is-selected')) {
        if (mediaType == 'model') {
          if (Shopify.media_queries.large.matches) {
            $slide.on('mouseenter', function() {
              $el.flickity('unbindDrag');
            });
            $slide.on('mouseleave', function() {
              $el.flickity('bindDrag');
            });
          }
        }

        $slide.keypress(function(event) {
          if(event.which == 13) {
            $slide.find('model-viewer, .product-gallery__link, .plyr').focus();
            $el.on('settle.flickity', function( event, index ) {
              if (mediaType == 'video' || mediaType == 'external_video') {
                checkForVideos();
              }
              if (mediaType == 'model') {
                autoplayModel();
              }
              $el.off('settle.flickity');
            });
          }
        })
      }
    })

    var $sliderArrows = $el.find('.flickity-prev-next-button');

    if (($sliderArrows.length || $thumbnails.length) && Shopify.media_queries.large.matches) {
      $sliderArrows.on('click', function() {
        $el.on('settle.flickity', function(event, index) {
          var mediaType = $el.find('.product-gallery__image.is-selected').data('media-type');
          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          }
          if (mediaType == 'model') {
            autoplayModel();
          }
          $el.off('settle.flickity');
        });
      })

      $sliderArrows.on('keypress', function(event) {
        if(event.which == 13) {
          $el.focus();
          $el.attr('tabindex', 0);
          $el.find('.product-gallery__image').attr('tabindex', 0);
        }
      })

      $thumbnails.on('click', function(event) {
        var index = $(event.currentTarget).index();
        $el.flickity('select', index);
        $el.on('settle.flickity', function(event, index) {
          var mediaType = $el.find('.product-gallery__image.is-selected').data('media-type');
          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          }
          if (mediaType == 'model') {
            autoplayModel();
          }
          $el.off('settle.flickity');
        });
      })

      $thumbnails.keypress(function(event) {
        var index = $(event.currentTarget).index();
        if(event.which == 13) {
          $el.flickity('select', index);
          $el.on( 'settle.flickity', function( event, index ) {
            var $selectedSlide = $el.find('.product-gallery__image.is-selected');
            var mediaType = $selectedSlide.data('media-type');
            $selectedSlide.find('[data-youtube-video]').attr('tabindex', '0');
            $selectedSlide.find('model-viewer, .plyr, .product-gallery__link').focus();
            if (mediaType == 'video' || mediaType == 'external_video') {
              checkForVideos();
            }
            if (mediaType == 'model') {
              autoplayModel();
            }
            $el.off('settle.flickity');
          });
        }
      })
    }

    function autoplayModel() {
      if (!galleryObject || !Array.isArray(galleryObject.models) || !galleryObject.models.length) {
        return;
      }

      $.each(galleryObject.models, function(index, model) {
        var $slide = $(model.container).parents('.product-gallery__image');
        if ($slide.hasClass('is-selected')) {
          model.play();
        }
      })
    }

    function checkForVideos() {
      var selectedMediaType = $el.find('.product-gallery__image.is-selected').data('media-type');

      if ((selectedMediaType == 'video' || selectedMediaType == 'external_video') && galleryObject.hasVideoMedia && !galleryObject.videoPlayersLoaded) {
        product.ensureGalleryPlyr(galleryObject).then(function() {
          checkForVideos();
        }).catch(function(error) {
          console.error('Failed to initialize product gallery video players', error);
        });
        return;
      }

      $slides.each(function(index, slide) {
        var $slide = $(slide);
        var mediaType = $slide.data('media-type');
        var videoID = $slide.find('video').data('plyr-video-id');
        var $iframeVideo = $slide.find('iframe');
        var iframeID = $iframeVideo.attr('id');
        if ($slide.hasClass('is-selected')) {
          if (mediaType == 'video') {
            videoID = $slide.find('video').data('plyr-video-id');
            if (videoID) {
              autoplayVideo(videoID, $slide);
            }
          } else if (mediaType == 'external_video') {
            if (iframeID) {
              autoplayYoutubeVideo(iframeID, $slide);
            }
          }
        }
      })
    }

    function autoplayVideo(videoID, $slide) {
      if (!galleryObject.videoPlayers) {
        return;
      }

      $.each(galleryObject.videoPlayers, function(index, player){
        if (player.id == videoID) {
          player.play();
          player.once('exitfullscreen', function(){
            var $thumbnailProductGallery = $slide.closest('.product-gallery').find('.product-gallery__thumbnails');
            if ($thumbnailProductGallery.hasClass('vertical-slider-enabled')) {
              $thumbnailProductGallery.attr('tabindex', '0').focus();
            } else {
              $thumbnailProductGallery.focus();
            }
          })
        }
      })
    }

    function autoplayYoutubeVideo(iframeID, $slide) {
      if (!galleryObject.videoPlayers) {
        return;
      }

      $.each(galleryObject.videoPlayers, function(index, player){
        if (player.playing) {
          player.pause();
        }
        if (player.media.id == iframeID) {
          player.play();
          player.once('exitfullscreen', function(){
            var $thumbnailProductGallery = $slide.closest('.product-gallery').find('.product-gallery__thumbnails');
            if ($thumbnailProductGallery.hasClass('vertical-slider-enabled')) {
              $thumbnailProductGallery.attr('tabindex', '0').focus();
            } else {
              $thumbnailProductGallery.focus();
            }
          })
        }
      })
    }

    if (galleryObject.thumbnailsEnabled == true) {
      if (galleryObject.thumbnailsSliderEnabled == true && $slides.length > 1) {
        if (Shopify.media_queries.large.matches) {
          if (galleryObject.thumbnailsPosition == 'left-thumbnails' || galleryObject.thumbnailsPosition == 'right-thumbnails') {
            $thumbnailProductGallery.css('max-height', $el.closest('.product-gallery').outerHeight());
            $thumbnailProductGallery.addClass('vertical-slider-enabled');

            $thumbnails.on('click', function(event) {
              var index = $(event.currentTarget).index();
              $el.flickity('select', index);
            });

            var navCellHeight = $thumbnails.height();
            var navHeight = $thumbnailProductGallery.height();

            $el.on( 'select.flickity', function() {
              var flkty = $el.data('flickity');
              $thumbnailProductGallery.find('.is-nav-selected').removeClass('is-nav-selected');
              var $selected = $thumbnails.eq( flkty.selectedIndex ).addClass('is-nav-selected');
              var scrollY = $selected.position().top + $thumbnailProductGallery.scrollTop() - ( navHeight + navCellHeight ) / 2;
              $thumbnailProductGallery.animate({ scrollTop: scrollY });
            });
          } else {
            $thumbnailProductGallery.flickity({
              cellAlign: 'left',
              contain: true,
              pageDots: false,
              prevNextButtons: false,
              freeScroll: true,
              asNavFor: $el[0]
            })

            $thumbnails.on('click', function(event) {
              var index = $(event.currentTarget).index();
              $el.flickity('select', index);
            })
          }
        } else {
          $thumbnailProductGallery.addClass('mobile-gallery');
          $el.flickity({
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true,
            asNavFor: $thumbnailProductGallery[0],
            imagesLoaded: true,
            watchCSS: false,
          })

          $thumbnailProductGallery.flickity({
            cellAlign: 'center',
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            wrapAround: true,
            freeScroll: true,
          })
        }
      }
    }
  },

  bindGalleryPlyrLoad: function(galleryObject, $galleryMain, $thumbnails) {
    if (!galleryObject.hasVideoMedia || galleryObject.plyrLazyBound) {
      return;
    }

    galleryObject.plyrLazyBound = true;

    var $targets = $galleryMain.add($thumbnails);
    var loadOnInteraction = function() {
      $targets.off('.plyrLazy');
      product.ensureGalleryPlyr(galleryObject).catch(function(error) {
        console.error('Failed to load Plyr for product gallery', error);
      });
    };

    $targets.on('pointerdown.plyrLazy touchstart.plyrLazy keydown.plyrLazy focusin.plyrLazy', loadOnInteraction);
  },

  ensureGalleryPlyr: function(galleryObject) {
    if (!galleryObject.hasVideoMedia) {
      return Promise.resolve(galleryObject);
    }

    if (galleryObject.plyrPromise) {
      return galleryObject.plyrPromise;
    }

    galleryObject.plyrPromise = utilities.loadPlyr().then(function(Plyr) {
      product.loadPlyr(galleryObject, galleryObject.videos);
      product.bindGalleryPlayerSync(galleryObject);
      galleryObject.videoPlayersLoaded = true;
      return galleryObject;
    });

    return galleryObject.plyrPromise;
  },

  bindGalleryPlayerSync: function(galleryObject) {
    if (!galleryObject.videoPlayers || galleryObject.videoSyncBound) {
      return;
    }

    galleryObject.videoSyncBound = true;

    $.each(galleryObject.videoPlayers, function(index, player) {
      player.on('play', function(event) {
        var instance = event.detail.plyr;
        $.each(globalPlayersArray, function(innerIndex, otherPlayer) {
          if (instance.id != otherPlayer.id) {
            otherPlayer.pause();
          }
        });
      });
    });
  },

  loadPlyr: function(galleryObject, videos, showSecondaryMedia) {
    if (typeof Plyr === 'undefined' || !videos || !videos.length) return;
    utilities.launchVideoPlayer(Plyr, galleryObject, videos, showSecondaryMedia);
  },

  launchProductMedia: function(galleryObject) {
    var sectionID = galleryObject.sectionID;
    if (sectionID) {
      var sectionSelector = sectionID.indexOf('shopify-section-') === 0 ? '#' + sectionID : '#shopify-section-' + sectionID;
      var $section = $(sectionSelector);
      var $model = $section.find('[data-media-type="model"]');
      if ($model.length) {
        import('//discgolfswag.com/cdn/shop/t/97/assets/shopify-model-viewer-ui?v=9529')
        .then(module => {
          var ModelViewerUi = module.default;
          galleryObject.models = [];
          $model.each(function() {
            var $this = $(this);
            var modelViewer = $this.find('model-viewer');
            if (modelViewer.length) {
              var model = new ModelViewerUi(modelViewer[0]);
              galleryObject.models.push(model);
            }
          });
        })
        .catch(function(error) {
          galleryObject.models = [];
          console.error('Failed to initialize product models', error);
        })
      }
    }
  },

  initProductRecommendations: function() {
    var $containers = $('[data-product-recommendations-container]');

    if (!$containers.length) {
      return;
    }

    function loadWhenReady(element) {
      product.loadProductRecommendations($(element));
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            loadWhenReady(entry.target);
          }
        });
      }, {
        rootMargin: '900px 0px'
      });

      $containers.each(function() {
        observer.observe(this);
      });
    } else {
      $containers.each(function() {
        loadWhenReady(this);
      });
    }
  },

  loadProductRecommendations: function($productRecommendationsContainer) {
    if (!$productRecommendationsContainer || !$productRecommendationsContainer.length) {
      return;
    }

    if ($productRecommendationsContainer.attr('data-recommendations-loaded') === 'true' || $productRecommendationsContainer.attr('data-recommendations-loading') === 'true') {
      return;
    }

    var recommendationsURL = $productRecommendationsContainer.data('recommendations-url');
    var productID = $productRecommendationsContainer.data('product-id');
    var requestUrl;

    if (!recommendationsURL || !productID) {
      return;
    }

    requestUrl = recommendationsURL + '?section_id=product-recommendations&product_id=' + productID;
    $productRecommendationsContainer.attr('data-recommendations-loading', 'true');

    $.ajax({
      type: 'GET',
      url: requestUrl,
      success: function(data) {
        var $recommendedProductsElement = $(data).find('.product-recommendations').first();

        $productRecommendationsContainer.removeAttr('data-recommendations-loading');
        $productRecommendationsContainer.attr('data-recommendations-loaded', 'true');

        if (!$recommendedProductsElement.length) {
          $productRecommendationsContainer.empty();
          return;
        }

        $productRecommendationsContainer.html($recommendedProductsElement);

        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (typeof collection !== 'undefined' && collection.unload) {
          collection.unload($('.shopify-section--recommended-products'));
        }
        if (typeof collection !== 'undefined' && collection.init) {
          collection.init();
        }
        product.productSwatches();

        
      },
      error: function() {
        $productRecommendationsContainer.removeAttr('data-recommendations-loading');
        $productRecommendationsContainer.empty();
      }
    });
  },

  unload: function($target){
    var $gallerySlider = $target.find('.product-gallery__main');
    var $thumbnailSlider = $target.find('.product-gallery__thumbnails');

    if ($gallerySlider.length && $gallerySlider.data('flickity')) {
      $gallerySlider.flickity('destroy');
    }

    if ($thumbnailSlider.length && $thumbnailSlider.data('flickity')) {
      $thumbnailSlider.flickity('destroy');
    }
    $target.find('img[data-zoom-src]').each(function() {
      if (product.zoomObserver) {
        product.zoomObserver.unobserve(this);
      }
      delete this.dataset.zoomInitialized;
    });
  }
}

/*============================================================================
  Product form
=============================================================================*/
var productFormListeners = {
  init: function(){
    $(document).on("click", ".minus", function(e) {
      var quantity = parseInt($(this).next("input").val());
      quantity -= 1;
      $(this).next("input").val(quantity);

      if (quantity == 0) {
        $(this).closest('li.cart_item').slideUp();
        setTimeout(ajaxSubmitCart, 500);
      } else {
        $(this).next("input").trigger('change');
      }

      e.stopPropagation();
      e.preventDefault();
      return false;
    });

    $(document).on("click", ".plus", function(e) {
      var quantity = parseInt($(this).prev("input").val());
      quantity += 1;
      $(this).prev("input").val(quantity).trigger('change');

      e.stopPropagation();
      e.preventDefault();
      return false;
    });

    $(document).on('click', '.cart__quantity input.quantity', function(e) {
      return false;
    });

    $(document).on("change", "#cart_form input[type='number']", function() {
      $("#cart_form").submit();
    });

    if ($('.tos_agree').length) {
      $('body').off('click.productTosSubmit', 'input[type="submit"]').on('click.productTosSubmit', 'input[type="submit"]', function(event) {
        var form = $(this).closest('form')[0];
        event.preventDefault();
        if($(this).parents('form').find('.tos_agree').length) {
          if ($(this).parents('form').find('.tos_agree').is(':checked')) {
            if (form) {
              form.submit();
            }
          } else {
            alert(Shopify.translation.agree_to_terms_warning);
            return false;
          }
        } else {
          if (form) {
            form.submit();
          }
        }
      });
    }
  },
  unload: function(){}
}

/*============================================================================
  AJAX Cart Functions
=============================================================================*/
function ajaxSubmitCart() {
  $("#cart_form").submit();
}

function ajaxUpdateCart(line_id, quantity, $cart) {
  var $input = $(".cart__quantity input[data-line-id='" + line_id + "']");
  var inventory = $input.data("inventory-quantity");
  var inventory_management = $input.data("inventory-management");
  var inventory_policy = $input.data("inventory-policy");
  var items_left_text;

  if (inventory == 0) {
    items_left_text = Shopify.translation.items_left_count_zero;
  } else if (inventory == 1) {
    items_left_text = Shopify.translation.items_left_count_one;
  } else {
    items_left_text = Shopify.translation.items_left_count_other;
  }

  var updated_quantity = quantity;

  if (inventory_management != null) {
    if (inventory_policy == "deny") {
      if (quantity > inventory) {
        $input.val(inventory);
        updated_quantity = inventory;
      }
    }
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + updated_quantity + '&line=' + line_id,
    dataType: 'json',
    success: function(cart) {
      if (updated_quantity == 0) {
        $input.closest('li.cart_item').slideUp(function() {
          refreshCart(cart);
        });
      } else {
        refreshCart(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if (XMLHttpRequest.responseText.indexOf('items') > -1) {
        $('.warning').remove();
        var warning = '<div class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</div>';
        $input.parent().next().append(warning);
        $input.val(updated_quantity);
      }
    }
  });
}

function refreshCart(cart) {
  var $cartBtn = $(".cart-button span");
  if ($cartBtn && $cartBtn.length) {
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var $cart = $("#cart ul");

    $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));
    $cart.find('li:not(:first)').remove();

    if (cart.item_count == 0) {
      $cart.append('<li class="empty_cart">' + Shopify.translation.empty_cart + '</li>');
    } else {
      $.each(cart.items, function(index, item) {
        var line_id = index + 1;
        var discountMessage = '';

        if (item.discounts.length) {
          var discountAmount = Shopify.formatMoney(item.discounts[0].amount, $('body').data('money-format'));
          var title = item.discounts[0].title;
          discountMessage = '<span class="notification-discount"><strong>' + Shopify.translation.cart_discount + ':</strong> ' + title + ' (-<span class="money">' + discountAmount + '</span>)</span>';
        }

        cart_items_html += '<li>' + '<a class="cart__item" href="' + item.url + '">';

        if (item.image) {
          cart_items_html += '<div class="cart__image">' + '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' + '</div>';
        }

        cart_items_html += '<div class="cart__info">' + '<div class="cart__description">' + item.title;

        if (item.price > item.final_price) {
          var itemPrice = '<span class="money">' + Shopify.formatMoney(item.final_line_price, $('body').data('money-format')) + '</span>' + ' <span class="was_price money">' + Shopify.formatMoney(item.original_line_price, $('body').data('money-format')) + '</span>';
          cart_items_html += '<div class="cart__price">' + itemPrice + '</div>' + discountMessage +'</div>'
        } else {
          var itemPrice = '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>';
          cart_items_html += '<div class="cart__price">' + itemPrice + '</div>';
        }

        cart_items_html += '</div>' + '<div class="cart__quantity">' + '<span class="icon-minus minus"></span>' + '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' + '<span class="icon-plus plus"></span>' + '</div></div></a>';

        if(item.properties) {
          $.each(item.properties, function(title, value) {
            if (value) {
              cart_items_html += '<div class="line-item">' + title +': ' + value + '</div>';
            }
          });
        }
      });

      var cartDiscounts = cart.cart_level_discount_applications;
      var cartDiscountMessage = "";

      for (var i = 0; i < cartDiscounts.length; i++) {
        var amount = Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        var title = cartDiscounts[i].title;
        cartDiscountMessage = '<p class="mm-counter price mm-discount-label mm-listitem__text">' + title + '<span>' + '(- <span class="money">' + amount + '</span>)' + '</span>' + '</p>';
      }

      if (cart.cart_level_discount_applications.length > 0) {
        cart_items_html += '<li class="mm-label mm-listitem">' + cartDiscountMessage + '</li>'
      }

      cart_items_html += '<li class="mm-label">' + '<a href="/cart" class="cart__item-subtotal">' + '<span><strong>' + Shopify.translation.subtotal + '</strong></span>' + '<span class="mm-counter price"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' + '</a>' + '</li>' + '<li class="mm-subtitle">';

      
      var cart_note = cart.note ? cart.note : '';
      cart_items_html += '<textarea id="cart-note" name="note" rows="2" placeholder="' + Shopify.translation.cart_notes + '" class="clearfix">' + cart_note + '</textarea>';
      

      

      cart_items_html += '<span class="mm-action_buttons mm-listitem__text"><a href="' + Shopify.theme_settings.cart_url + '" class="action_button edit_cart left">' + Shopify.translation.edit_cart + '</a>' + '<input type="submit" class="action_button right" value="' + Shopify.translation.checkout + '"/></span></li>';

      $cart.append(cart_items_html);
      $cart.find('li.cart_item:last').addClass('last_cart_item');
    }
  }
}



$('body').on("change", "#cart input.quantity", function() {
  ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart'));
});

$('body').on("change", "#cart #cart-note", function() {
  ajaxSubmitCart();
});

$(function() {
  product.init();
  productFormListeners.init();
});
